import styled, { css } from 'styled-components'
import { size } from 'ui/themes/utils'

export const Services = styled.div`
  padding: 0 var(--minicart-padding);
  padding-bottom: 12px;
  margin-bottom: 16px;

  border-bottom: 1px solid var(--minicart-border-color);

  color: var(--minicart-typo-color);

  font-size: var(--minicart-font-size);

  height: ${({ open, headerHeight }) => open ?
      css`auto` :
      css`${headerHeight}px`
  };
  max-height: 150px;

  overflow: ${({ open }) => open ? 'auto' : 'hidden'};
  position: relative;

  transition: height 0.3s ease, max-height 0.3s ease;
`

export const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr repeat(2, max-content);
  gap: ${size('margin', 'xs')};

  position: sticky;
  top: 0;
  left: 0;

  padding-bottom: var(--minicart-padding);
  background-image: ${({ open }) => css`linear-gradient(
    to bottom,
    var(--minicart-background-color) 60%,
    color-mix(in srgb, var(--minicart-background-color) ${open ? 0 : 100}%, transparent)
  )`};

  align-items: center;
  justify-content: space-between;

  font-size: var(--minicart-font-size);

  cursor: pointer;
`

export const Title = styled.span``

export const Total = styled.span`
  font-weight: var(--minicart-font-weight-bold);
`

export const Service = styled.div`
  display: flex;
  align-items: center;

  label {
    margin: 0;
  }

  & > span {
    margin-right: 0.9em;
    cursor: pointer;
  }

  & > span.price {
    margin-left: auto;
    margin-right: 0;

    font-weight: var(--minicart-font-weight-bold);

    cursor: default;
  }

  &:not(:last-child) {
    margin-bottom: 0.7em;
  }
`

Services.Header = Header
Services.Service = Service
Services.Title = Title
Services.Total = Total

export default Services
